<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="用户">
					<el-select v-model="listQuery.search.uid" filterable clearable placeholder="请选择">
						<el-option v-for="item in user_all" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类型">
					<el-select style="width: 120px;" v-model="listQuery.search.type" filterable clearable
						placeholder="请选择">
						<el-option label="线下充值" value="1"></el-option>
						<el-option label="扣款" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="币种">
					<el-select style="width: 120px;" v-model="listQuery.search.currency_type" filterable clearable
						placeholder="请选择">
						<el-option v-for="item in currency" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="listQuery.search.remarks" clearable placeholder="请填写"></el-input>
				</el-form-item>
				<el-form-item label="金额">
					<el-input v-model="listQuery.search.money" clearable placeholder="请填写"></el-input>
				</el-form-item>
				<dtp :time="listQuery.search.create_time" label_name="" @getTime="getTime" />
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:50px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
			<el-button type="danger" style="float: right;" @click="moneyChange">充值/扣款</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="ac_uid_name" label="操作员"></el-table-column>
				<el-table-column prop="uid_name" label="用户"></el-table-column>
				<el-table-column prop="create_time" label="日期">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type_name" label="类型"> </el-table-column>
				<el-table-column prop="currency_type_init" label="币种"> </el-table-column>
				<el-table-column prop="money" label="金额">
					<template slot-scope="{row}">
						<span v-if="row.type == 1" style="color:#67C23A">+ {{row.money}}</span>
						<span v-else style="color:#F56C6C">- {{row.money}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="balance" label="账户余额"> </el-table-column>
				<el-table-column prop="remarks" label="备注"> </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 充值/扣款 -->
			<el-dialog title="充值/扣款" width="40%" :visible.sync="is_show_money">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item label="用户:">
							<el-col :span="12">
								<el-select v-model="money_data.uid" filterable clearable placeholder="请选择">
									<el-option v-for="item in user_all" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="类型:">
							<el-col :span="12">
								<el-radio-group v-model="money_data.type">
									<el-radio :label="1">线下充值</el-radio>
									<el-radio :label="2">扣款</el-radio>
								</el-radio-group>
							</el-col>
						</el-form-item>
						<el-form-item label="币种:">
							<el-col :span="20">
								<el-radio-group v-model="money_data.currency_type">
									<el-radio v-for="item in currency" :label="item.value">{{item.label}}</el-radio>
								</el-radio-group>
							</el-col>
						</el-form-item>

						<el-form-item label="金额:">
							<el-col :span="24">
								<el-input-number v-model="money_data.money" :precision="2" :step="100" :min="0.00">
								</el-input-number>
							</el-col>
						</el-form-item>
						<el-form-item label="备注:">
							<el-col :span="16">
								<el-input :rows="4" type="textarea" placeholder="请输入" maxlength="200" show-word-limit
									v-model="money_data.remarks">
								</el-input>
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_money = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="moneyChange2()">确定
					</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		rkList,
		rk
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				currency: [], // 所有币种
				is_show_search: false,
				role_body: '',
				user_all: [], // 所有用户
				is_show_money: false,
				money_data: {
					uid: '',
					type: 1,
					currency_type: 0,
					money: 0,
					remarks: '',
				}
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						uid: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				rkList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;

					if (this.listQuery.page == 1) {
						this.currency = r.currency;
						this.role_body = r.role_body;
						this.user_all = r.user_all;
					}

					this.loading = false;
				})
			},
			// 充值/扣款 - 点击
			moneyChange() {
				this.money_data = {
					uid: '',
					type: 1,
					currency_type: 0,
					money: 0,
					remarks: '',
				};
				this.is_show_money = true;
			},
			// 充值/扣款 - 提交
			moneyChange2() {
				this.$store.commit('setAjaxLoading', true);
				rk(Qs.stringify(this.money_data)).then(response => {
					this.getList();
					this.is_show_money = !this.is_show_money;
					alertMsg(this, '操作成功', 'success');
				})
			},
			// 获取时间选择
			getTime(time) {
				this.listQuery.search.create_time = time;
			},
		}
	}
</script>
<style>

</style>
